import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircle,
  faQuestionCircle,
  faExclamationTriangle,
  faCommentDots,
  faSearch,
  faWindowClose,
  faIndustry,
  faHandshake,
  faEnvelope,
  faEnvelopeOpenText,
  faFileExport,
  faExternalLinkAlt,
  faClipboardCheck,
} from "@fortawesome/free-solid-svg-icons";

var foreGroundColor = "#014891";
var backGroundColor = "#dae3ec";

const IncidentIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon
      className="fas fa-solid fa-stack-1x"
      icon={faExclamationTriangle}
    />
  </span>
);

const IncidentUpdateRequestIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon
      className="fas fa-solid fa-stack-1x"
      icon={faQuestionCircle}
    />
  </span>
);

const ComplianceInvestigationIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon className="fas fa-solid fa-stack-1x" icon={faSearch} />
  </span>
);

const ComplaintIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon
      className="fas fa-solid fa-stack-1x"
      icon={faCommentDots}
    />
  </span>
);

const MeetingIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon className="fas fa-solid fa-stack-1x" icon={faHandshake} />
  </span>
);

const NonComplianceIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon
      className="fas fa-solid fa-stack-1x"
      icon={faWindowClose}
    />
  </span>
);

const SiteVisitIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon className="fas fa-solid fa-stack-1x" icon={faIndustry} />
  </span>
);

const EPAInitiatedCorrespondenceIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon className="fas fa-solid fa-stack-1x" icon={faEnvelope} />
  </span>
);

const ThirdPartyCorrespondenceIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon
      className="fas fa-solid fa-stack-1x"
      icon={faEnvelopeOpenText}
    />
  </span>
);

const LicenseeReturnIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon className="fas fa-solid fa-stack-1x" icon={faFileExport} />
  </span>
);

const ActionOrInstructionIcon = () => (
  <span style={{ color: foreGroundColor }} className="fa-stack">
    <FontAwesomeIcon
      style={{ color: backGroundColor }}
      className="fas fa-stack-2x icon-background"
      icon={faCircle}
    />
    <FontAwesomeIcon
      className="fas fa-solid fa-stack-1x"
      icon={faClipboardCheck}
    />
  </span>
);

const ExternalLinkIcon = () => (
  <FontAwesomeIcon className="fas fa-solid" icon={faExternalLinkAlt} />
);

const getIconForType = (type: string) => {
  switch (type) {
    case "Incident":
      return <IncidentIcon />;
    case "Complaint":
      return <ComplaintIcon />;
    case "Compliance Investigation":
      return <ComplianceInvestigationIcon />;
    case "Non Compliance":
      return <NonComplianceIcon />;
    case "Site Visit":
      return <SiteVisitIcon />;
    case "Meeting":
      return <MeetingIcon />;
    case "3rd Party Correspondence":
      return <ThirdPartyCorrespondenceIcon />;
    case "EPA Initiated Correspondence":
      return <EPAInitiatedCorrespondenceIcon />;
    default:
      return <LicenseeReturnIcon />;
  }
};

export {
  IncidentIcon,
  ComplianceInvestigationIcon,
  ComplaintIcon,
  NonComplianceIcon,
  SiteVisitIcon,
  LicenseeReturnIcon,
  getIconForType,
  ExternalLinkIcon,
  IncidentUpdateRequestIcon,
  ActionOrInstructionIcon,
  EPAInitiatedCorrespondenceIcon,
  ThirdPartyCorrespondenceIcon,
};
